import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../estilos/StyNav.css";
import logo from "../img-etc/logo.png";
import { useTranslation } from 'react-i18next';
import { ruta, rutaEquivalente, identificarRuta, idiomaValido } from "../rutas";

function Navega() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const indicatorRef = useRef(null);
  const menuRef = useRef(null);
  const linksRef = useRef([]);
  const isFirstRender = useRef(true);
  const { t, i18n } = useTranslation();
  const lang = idiomaValido(i18n.language);

  const menu = [
    { label: t('nav_home'), pagina: 'home' },
    { label: t('nav_quienes'), pagina: 'nosotros' },
    { label: t('nav_contacto'), pagina: 'contacto' },
    { label: t('nav_experiencias'), pagina: 'todas' },
    { label: t('nav_reseñas'), pagina: 'resenas' }
  ].map((m) => ({ ...m, path: ruta(m.pagina, lang) }));

  // Página actual (para marcar el link activo).
  const paginaActual = identificarRuta(location.pathname)?.pagina;

  // Cambia de idioma yendo a la misma página en el otro idioma (/... ↔ /en/...).
  const cambiarIdioma = () => {
    const nuevo = lang === 'es' ? 'en' : 'es';
    i18n.changeLanguage(nuevo);
    navigate(rutaEquivalente(location.pathname, nuevo) + location.search);
  };

  useEffect(() => {
    const index = menu.findIndex((m) => m.pagina === paginaActual);
    const link = linksRef.current[index];
    const menuEl = menuRef.current;

    if (link && indicatorRef.current && menuEl) {
      const linkRect = link.getBoundingClientRect();
      const menuRect = menuEl.getBoundingClientRect();
      const offsetLeft = linkRect.left - menuRect.left;
      
      if (isFirstRender.current) {
        indicatorRef.current.style.transition = 'none';
      }
      
      indicatorRef.current.style.width = `${linkRect.width}px`;
      indicatorRef.current.style.transform = `translateX(${offsetLeft}px)`;
      
      if (isFirstRender.current) {
        requestAnimationFrame(() => {
          if (indicatorRef.current) {
            indicatorRef.current.style.transition = '';
          }
          isFirstRender.current = false;
        });
      }
    }
  }, [location.pathname, i18n.language]);

  return (
    <header className="nav">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => navigate(ruta("home", lang))}>
          <img src={logo || "/placeholder.svg"} alt="Pacific Tour CR" />
        </div>

        <nav ref={menuRef} className={`nav-menu ${open ? "open" : ""}`}>
          {menu.map((item, i) => (
            <button
              key={item.label}
              ref={(el) => (linksRef.current[i] = el)}
              className={`nav-link ${item.pagina === paginaActual ? "active" : ""}`}
              onClick={() => {
                navigate(item.path);
                setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
          <span ref={indicatorRef} className="nav-indicator" />
        </nav>

        {/* BOTÓN IDIOMA */}
        <button className="btn-idioma" onClick={cambiarIdioma}>
          {lang === "es" ? "🇺🇸 EN" : "🇨🇷 ES"}
        </button>

        <button
          className={`nav-toggle ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {open && (
        <div className="nav-mobile">
          {menu.map((item) => (
            <button
              key={item.label}
              className={`nav-mobile-link ${item.pagina === paginaActual ? "active" : ""}`}
              onClick={() => {
                navigate(item.path);
                setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}

export default Navega;